// libraries.
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { electricPurple500, monserratSemiBold } from "@habitech/shared";

// hook.
import { useCreateRuleForm } from "./useCreateRuleForm";

// components.
import { CreateRuleFields } from "./CreateRuleFields";

// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// ─── Props ────────────────────────────────────────────────────────────────────

interface Props {
  show: boolean;
  country: string;
  subRutaId: number;
  stateRoute: 1 | 2;
  onClose: () => void;
  // Si se proporciona, el modal funciona en modo editar (PUT /rules)
  editRule?: RawRuleItem | null;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const CreateRuleModal = ({
  show,
  country,
  subRutaId,
  stateRoute,
  onClose,
  editRule,
}: Props) => {
  const {
    methods,
    onSubmit,
    isSaving,
    isEditMode,
    tools,
    contextVars,
    isLoadingTools,
    subConditionArray,
    actionArray,
    emptySubCondition,
    emptyAction,
    subRutasOptions,
  } = useCreateRuleForm({ show, country, onClose, subRutaId, stateRoute, editRule });

  const title = isEditMode ? "Editar regla" : "Nueva regla";
  const submitLabel = isEditMode ? "Guardar cambios" : "Crear regla";

  return (
    <Modal show={show} onHide={onClose} centered size="lg" scrollable>
      <Modal.Header
        closeButton
        style={{ borderBottom: `2px solid ${electricPurple500}` }}
      >
        <Modal.Title
          style={{ fontFamily: monserratSemiBold, fontWeight: 600, fontSize: 16 }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form id="create-rule-form" onSubmit={onSubmit}>
          <CreateRuleFields
            register={methods.register}
            errors={methods.formState.errors}
            watch={methods.watch}
            setValue={methods.setValue}
            tools={tools}
            contextVars={contextVars}
            isLoadingTools={isLoadingTools}
            subConditionArray={subConditionArray}
            actionArray={actionArray}
            emptySubCondition={emptySubCondition}
            emptyAction={emptyAction}
            isEditMode={isEditMode}
            subRutasOptions={subRutasOptions}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #eee" }}>
        <Button className="btn-habi-white" onClick={onClose} disabled={isSaving}>
          Cancelar
        </Button>
        <Button
          type="submit"
          form="create-rule-form"
          className="btn-habi"
          disabled={isSaving || isLoadingTools}
        >
          {isSaving ? <Spinner size="sm" animation="border" /> : submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
